<ng-container *ngVar="(filterLabel$ | async) as filterLabel">
  <a class="badge badge-primary"
     [attr.aria-label]="'search.filters.remove' | translate:{ type: ('search.filters.applied.f.' + appliedFilter.filter) | translate, value: filterLabel }"
     [routerLink]="searchLink"
     [queryParams]="(removeParameters$ | async)">
  <span class="d-flex">
    <span class="flex-grow-1 text-left">{{ ('search.filters.applied.f.' + appliedFilter.filter) | translate}}{{'search.filters.applied.operator.' + appliedFilter.operator | translate}}: {{'search.filters.' + appliedFilter.filter + '.' + filterLabel | translate: { default: filterLabel } }}</span>
    <span class="pl-1" aria-hidden="true">×</span>
  </span>
  </a>
</ng-container>
